import React, { useState, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import './RichTextEditor.css';

const TOOLS = [
  { label: 'B', title: 'Bold', insert: '**', wrap: true },
  { label: 'I', title: 'Italic', insert: '*', wrap: true },
  { label: 'H', title: 'Heading', insert: '## ', wrap: false },
  { label: '•', title: 'Bullet list', insert: '- ', wrap: false },
  { label: '1.', title: 'Numbered list', insert: '1. ', wrap: false },
  { label: '`', title: 'Code', insert: '`', wrap: true },
  { label: '>', title: 'Quote', insert: '> ', wrap: false },
  { label: '—', title: 'Divider', insert: '\n---\n', wrap: false },
  { label: '🔗', title: 'Link', insert: '[', suffix: '](url)', wrap: false },
];

export default function RichTextEditor({ value, onChange, placeholder, rows }) {
  const textareaRef = useRef(null);
  const [preview, setPreview] = useState(false);

  const insertMarkdown = (tool) => {
    const el = textareaRef.current;
    if (!el) return;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    const text = value || '';
    const before = text.substring(0, start);
    const selected = text.substring(start, end);
    const after = text.substring(end);

    let newText;
    if (tool.wrap && selected) {
      newText = before + tool.insert + selected + tool.insert + after;
    } else if (tool.wrap) {
      const word = before.split(/\s/).pop() || '';
      const beforeWord = before.substring(0, before.length - word.length);
      newText = beforeWord + tool.insert + word + tool.insert + after;
    } else if (tool.suffix) {
      newText = before + tool.insert + selected + tool.suffix + after;
    } else {
      newText = before + tool.insert + selected + after;
    }

    onChange(newText);
    setTimeout(() => {
      el.focus();
      el.selectionStart = el.selectionEnd = start + tool.insert.length + (tool.wrap ? 0 : 0);
    }, 0);
  };

  return (
    <div className="rte-container">
      <div className="rte-toolbar">
        {TOOLS.map(t => (
          <button key={t.label} className="rte-btn" title={t.title} type="button" onClick={() => insertMarkdown(t)}>
            {t.label}
          </button>
        ))}
        <div className="rte-spacer" />
        <button className={`rte-btn rte-toggle ${preview ? 'active' : ''}`} title="Preview" type="button" onClick={() => setPreview(!preview)}>
          👁
        </button>
      </div>
      {preview ? (
        <div className="rte-preview" onClick={() => setPreview(false)}>
          {value ? <ReactMarkdown>{value}</ReactMarkdown> : <em style={{color:'#94a3b8'}}>Nothing to preview</em>}
        </div>
      ) : (
        <textarea
          ref={textareaRef}
          className="rte-textarea"
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          rows={rows || 6}
        />
      )}
    </div>
  );
}
